export const USER_LANGUAGE_COOKIE = 'django_language';
export const COOKIE_LIFESPAN = 30; // days

export const RUS = 'ru-RU';
export const ENG = 'en-US';
